// extracted by mini-css-extract-plugin
export default {"options_container":"Settings_options_container__IrmOZ","help_container":"Settings_help_container__+w-t9","text":"Settings_text__hBohk","space":"Settings_space__mLZnO"};